import { ModifiersClassNames } from "react-day-picker";

export const modifiersClassNames: ModifiersClassNames = {
  today: "DatePicker__today",
  selected: "DatePicker__highlight",
  weekend: "DatePicker__weekend",
};
